import { types } from "../action-types";

const initialState = {
  loading: false,
  active: [],
  inactive: [],
  pending: [],
  error: false,

  AddMemberloading: false,
  success: false,
  error: false,
  response: [],
};

const TeamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PENDING_TEAM_REQUESTED:
      return {
        ...state,
        loading: true,
        pending: []
      };

    case types.GET_PENDING_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        pending: action.payload,
        error: false,
      };
    case types.GET_PENDING_TEAM_FAILURE:
      return {
        ...state,
        loading: false,
        pending: [],
        error: true,
      };

    case types.GET_ACTIVE_TEAM_REQUESTED:
      return {
        ...state,
        loading: true,
        active: []
        };
  
    case types.GET_ACTIVE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        active: action.payload,
        error: false,
        };
      case types.GET_ACTIVE_TEAM_FAILURE:
        return {
        ...state,
        loading: false,
        active: [],
        error: true,
        };

      case types.GET_INACTIVE_TEAM_REQUESTED:
        return {
          ...state,
          loading: true,
          inactive: []
          };
      
      case types.GET_INACTIVE_TEAM_SUCCESS:
        return {
          ...state,
          loading: false,
          inactive: action.payload,
          error: false,
          };
      case types.GET_INACTIVE_TEAM_FAILURE:
        return {
          ...state,
          loading: false,
          inactive: [],
          error: true,
          };
  

    case types.ADD_TEAM_REQUESTED:
      return {
        ...state,
        AddMemberloading: true,
        success: false,
      };

    case types.ADD_TEAM_SUCCESS:
      return {
        ...state,
        AddMemberloading: false,
        success: true,
        error: false,
        response: action.payload,
      };

    case types.ADD_TEAM_FAILURE:
      return {
        ...state,
        AddMemberloading: false,
        success: false,
        error: true,
        response: action.payload.message,
      };
    case types.ADD_TEAM_RESET:
      return {
        ...state,
        AddMemberloading: false,
        success: false,
        error: false,
        response: [],
      };
    default:
      return state;
  }
};

export default TeamMembersReducer;
